import React from 'react';
import { createSvgIcon } from '../utils/createSvgIcon';

export const HexagonBadgeFilters = createSvgIcon(({ borderRadius }) => (
    <defs>
      {/* Add outer round corners and shadow */}
      <filter id='svg-round-corners-filter'>
        <feGaussianBlur in='SourceGraphic' stdDeviation={borderRadius} result='blur' />
        <feColorMatrix in='blur' mode='matrix' values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9' result='rounded' />
        <feComposite in='SourceGraphic' in2='rounded' operator='atop' />
        <feDropShadow dx="0" dy="2" stdDeviation="1.5" floodOpacity="0.15"/>
      </filter>

      {/* Add inner stroke and round inner figure corners */}
      <filter id='svg-rounded-stroke-corners'>
        <feGaussianBlur in='SourceGraphic' stdDeviation={borderRadius} result='blur' />
        <feColorMatrix in='blur' mode='matrix' values='1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 19 -9' result='rounded' />
        <feComposite in='SourceGraphic' in2='rounded' operator='atop' result='rounded' />

        {/* Figure stroke */}
        <feFlood floodColor='white' result='stroke-color' />
        <feMorphology in='SourceAlpha' operator='dilate' radius='2' />
        <feComposite in='stroke-color' operator='in' result='outside-stroke' />

        <feMerge>
          <feMergeNode in='outside-stroke' />
          <feMergeNode in='rounded' />
        </feMerge>
      </filter>
    </defs>
  ),
  '0 0 0 0'
);
